function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

export default function() {
  return this.each(raise);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/selection/raise.js
// module id = ../../../../d3-selection/src/selection/raise.js
// module chunks = 4